import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'utils/translate';
import RadioButton from '../RadioButton';
import QuestionMark from 'components/QuestionMark';

import './styles.scss';

const propTypes = {
  required: PropTypes.bool,
  value: PropTypes.any,
  label: PropTypes.string,
  id: PropTypes.string,
  useGrid: PropTypes.bool,
  customError: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
      valid: PropTypes.bool
    })
  ).isRequired
};

const defaultProps = {
  required: false,
  value: null,
  options: []
};

class RadioButtonGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredError: false,
      invalidValue: false
    };
  }

  onBlur = () => {
    const { required, value } = this.props;

    this.setState({
      requiredError: value === null && required
    });
  };

  onChange = newValue => {
    const { required, onChange, options } = this.props;

    if (onChange) {
      onChange(newValue);
    }

    if (newValue === null) {
      this.setState({
        requiredError: required,
        invalidValue: false
      });
      return;
    } else {
      const selected = options.find(option => option.value === newValue);

      this.setState({
        requiredError: false,
        invalidValue: selected.valid === false
      });
    }
  };

  getErrorResponse = () => {
    const { customError } = this.props;
    const { requiredError, invalidValue } = this.state;

    let error;

    if (invalidValue) {
      error = customError || 'Falscher Wert';
    } else if (requiredError) {
      error = 'Eingabe erforderlich!';
    }

    return <span className="field-error-message">{i18n(error)}</span>;
  };

  render() {
    const { requiredError, invalidValue } = this.state;
    const { options, value, prefix, className, useGrid, label, id, questionMark, questionMarkImage } = this.props;

    const isError = requiredError || invalidValue;
    let tooltip;

    if (questionMark) {
      tooltip = <QuestionMark content={questionMark} />;
    } else if (questionMarkImage) {
      tooltip = <QuestionMark image={questionMarkImage} />;
    }

    return (
      <div className={`responsive-field ${className} radio-group-wrapper ${isError ? 'radio-group-error ' : ''}`}>
        <label className="responsive-field__label" htmlFor={id}>
          {label} {tooltip}
        </label>
        <div>
          {options.map(option => (
            <RadioButton
              key={`${prefix}-${option.label}`}
              className={useGrid ? 'col-sm-12 col-md-4' : ''}
              id={`${prefix}-${option.label}`}
              text={i18n(option.label)}
              checked={value === option.value}
              onChange={() => this.onChange(option.value)}
              questionMark={option.questionMark}
            />
          ))}
        </div>
        <div className="row">
          <div className="col-xs-12">{this.getErrorResponse()}</div>
        </div>
      </div>
    );
  }
}

RadioButtonGroup.propTypes = propTypes;
RadioButtonGroup.defaultProps = defaultProps;

export default RadioButtonGroup;
